import { motion } from "framer-motion";
import { Shield } from "lucide-react";
import { AnimatedSection, fadeUp } from "@/components/motion";
import { IMAGES } from "./images";

const qualityPoints = [
  { title: "Multi-stage quality checks", desc: "Rigorous inspection at every production phase" },
  { title: "Advanced finishing techniques", desc: "Premium finish that meets international standards" },
  { title: "Careful packaging for global transit", desc: "Protection designed for long-distance shipping" },
];

export const QualitySection = () => (
  <AnimatedSection id="quality" className="py-24 lg:py-32 bg-white">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-16 items-center">
        <motion.div variants={fadeUp} className="relative overflow-hidden aspect-[4/3]">
          <img src={IMAGES.machinery} alt="Quality control" className="w-full h-full object-cover" />
        </motion.div>
        <motion.div variants={fadeUp}>
          <p className="text-xs font-sans uppercase tracking-[0.2em] text-[#C5A059] mb-4">Quality</p>
          <h2 className="text-4xl md:text-5xl font-serif tracking-tight text-foreground mb-6">
            Precision in Every Detail
          </h2>
          <p className="text-base font-sans text-muted-foreground leading-relaxed mb-8">
            Our processes are built to ensure consistency, durability, and premium finish across every product.
          </p>
          <ul className="space-y-5">
            {qualityPoints.map((item) => (
              <li key={item.title} className="flex items-start gap-4">
                <Shield size={20} className="text-[#C5A059] mt-0.5 flex-shrink-0" />
                <div>
                  <p className="font-sans font-medium text-foreground text-sm">{item.title}</p>
                  <p className="font-sans text-muted-foreground text-sm mt-1">{item.desc}</p>
                </div>
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </div>
  </AnimatedSection>
);
